import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import type { ListedPaymentPlanConsentDto } from "./usePaymentPlanConsentList"

export type PaymentPlanConsentDetailsResponse = ListedPaymentPlanConsentDto & {
  status: string
}

type HookParams = {
  paymentPlanConsentId: string | null
}

export function usePaymentPlanConsentDetails({ paymentPlanConsentId }: HookParams) {
  return useQuery<PaymentPlanConsentDetailsResponse>({
    queryKey: ["paymentPlanConsent", paymentPlanConsentId],
    queryFn: async () => {
      const response = await fetcher(
        `/Transaction/PaymentPlanConsent/${paymentPlanConsentId}`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
          doNotLogOutOn401: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
    enabled: Boolean(paymentPlanConsentId),
  })
}
